import { AppContext } from 'context';
import React, { useContext } from 'react';
import { Navigate, Route } from 'react-router-dom';

const PublicRoute = ({ component: Component, redirect, ...rest }) => {
	const { authenticated } = useContext(AppContext);

	return (
		<Route
			{...rest}
			render={(props) =>
				!!authenticated ? <Navigate to="/" /> : <Component {...props} />
			}
		/>
	);
};

export default PublicRoute;
